import React, {useEffect, useRef, useState} from 'react';
import { GlobalState } from "contexts/GlobalState";
import useSearch from "hooks/useSearch";

export default function useFocus(needCustomFocus, labels) {
  const keysPressed = useRef({});

  const [globalSearch, setGlobalSearch] = GlobalState("search");
  const { searchPrograms } = useSearch();
  
  useEffect(() => {
    if(needCustomFocus) {
      // add listeners for the custom focus order in calc page
      document.addEventListener('keydown', (event) => {
        keysPressed.current[event.key] = true;
      });
      document.addEventListener('keyup', (event) => {
        delete keysPressed.current[event.key];
      });
    }
  },[])

  const customFocusOnTab = (event, elementId) => {
    if(elementId=="title_searchResult0"){
      document.getElementById(elementId).focus();
    }
    keysPressed.current[event.key] = true;
      if (keysPressed.current.Tab && !keysPressed.current.Shift && document.getElementById(elementId)) {
          event.preventDefault();
          document.getElementById(elementId).focus();
      }
  }

  const customHandleClick = (buttonTitle) => {
    //search for programs only in the clicked faculty
    const ourFilters = {...globalSearch.filters}
    if (buttonTitle === labels?.all) {
        delete ourFilters.facultyName;
    }
    else {
        ourFilters.facultyName = buttonTitle;
    }
    searchPrograms(ourFilters);
  }

  const customFocusOnShiftTab = (event, elementId) => {
    keysPressed.current[event.key] = true;
    if (keysPressed.current.Tab && keysPressed.current.Shift && document.getElementById(elementId)) {
      event.preventDefault();
      document.getElementById(elementId).focus();
    }
  }

  return { customFocusOnTab, customFocusOnShiftTab, customHandleClick }
}